module.exports = __webpack_public_path__ + "img/logo.40f6ae65.png";